import React from 'react';

import PropTypes from 'prop-types';

import TableCell from 'components/application/TableCell';
import Tooltip from 'components/application/Tooltip';

import { resourceShape } from 'components/helpers/serialisableResources';
import { personDisplayName } from 'components/helpers/users';

export default function TeamsRow({ company, managers, onTeamRowClick, team }) {
  const managerNamesList = managers
    .map((manager) => personDisplayName({ attributes: manager.attributes }))
    .join(', ');

  return (
    <tr
      className='handshq__tr--clickable tw-h-[49px] hover:tw-bg-grey-025'
      onClick={() => onTeamRowClick(team.id)}
    >
      <TableCell>
        <span className='truncated-text-container tw-text-m tw-font-medium tw-text-grey-900'>
          {team.attributes.name}
        </span>
      </TableCell>
      <TableCell>
        <div className='tooltip-parent truncated-text-container tw-text-m'>
          <span className='tw-text-m tw-font-medium tw-text-grey-900'>
            {managerNamesList}
          </span>
          {managerNamesList.length > 42 && (
            <Tooltip
              placement='top'
              tooltip={managerNamesList}
              trigger='hover'
            />
          )}
        </div>
      </TableCell>
      <TableCell>
        <div className='tw-text-m'>{company.attributes.name}</div>
      </TableCell>
      <TableCell justifyContent='center'>
        <div className='tw-text-m'>{team.meta.teamMembersCount}</div>
      </TableCell>
    </tr>
  );
}

TeamsRow.propTypes = {
  company: resourceShape('company').isRequired,
  managers: PropTypes.arrayOf(resourceShape('user')),
  onTeamRowClick: PropTypes.func.isRequired,
  team: resourceShape('team').isRequired,
};
